import coinImage from '../../assets/coin-image.png';
import Styles from './Coin.module.css';

const Coin = ({ size = 20, spin = false }) => (
  <img
    src={coinImage}
    alt=""
    aria-hidden="true"
    draggable={false}
    width={size}
    height={size}
    className={`${Styles.coin} ${spin ? Styles.spin : ''}`}
  />
);

export default Coin;